import { render, staticRenderFns } from "./Breakpoint.vue?vue&type=template&id=d5352c20&scoped=true"
import script from "./Breakpoint.vue?vue&type=script&lang=js"
export * from "./Breakpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5352c20",
  null
  
)

export default component.exports